/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BlogContent_post = {
    readonly contentJson: string;
    readonly " $refType": "BlogContent_post";
};
export type BlogContent_post$data = BlogContent_post;
export type BlogContent_post$key = {
    readonly " $data"?: BlogContent_post$data;
    readonly " $fragmentRefs": FragmentRefs<"BlogContent_post">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BlogContent_post",
  "type": "BlogPost",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentJson",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'fcc430cfd706a95b90a1498713ea4af4';
export default node;
